import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import api from '../../services/api';
import Select from 'react-select';
import ProfessionModal from './ProfessionModal';
import ReligionModal from './ReligionModal';
import { useSelectStyles } from '../../utils/selectStyles';

const ParentModal = ({ onClose, onSuccess }) => {
  const { register, handleSubmit, setValue, watch, formState: { errors } } = useForm();
  const selectStyles = useSelectStyles();
  const [typesParentes, setTypesParentes] = useState([]);
  const [professions, setProfessions] = useState([]);
  const [religions, setReligions] = useState([]);
  const [showProfessionModal, setShowProfessionModal] = useState(false);
  const [showReligionModal, setShowReligionModal] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      const [typesRes, profsRes, relsRes] = await Promise.all([
        api.get('/types_parentes'),
        api.get('/professions'),
        api.get('/religions')
      ]);
      setTypesParentes(typesRes.data.data || []);
      setProfessions(profsRes.data.data || []);
      setReligions(relsRes.data.data || []);
    };
    fetchData();
  }, []);

  const onSubmit = async (data) => {
    await api.post('/parents', data);
    onSuccess(data);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-30 dark:bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg p-8 w-full max-w-2xl">
        <h2 className="text-xl font-semibold mb-4 dark:text-gray-100">Ajouter un parent</h2>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Type *</label>
              <Select
                options={typesParentes.map(tp => ({ value: tp.id, label: tp.libelle }))}
                value={typesParentes.find(tp => tp.id === watch('type_parente_id')) ? { value: watch('type_parente_id'), label: typesParentes.find(tp => tp.id === watch('type_parente_id')).libelle } : null}
                onChange={opt => setValue('type_parente_id', opt ? opt.value : '')}
                isClearable
                placeholder="Sélectionner le type"
                classNamePrefix="react-select"
                styles={selectStyles}
              />
              {errors.type_parente_id && <span className="text-red-500 dark:text-red-400 text-xs mt-1">Champ obligatoire</span>}
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Profession</label>
              <div className="flex items-center gap-2">
                <div className="flex-1">
                  <Select
                    options={professions.map(p => ({ value: p.id, label: p.profession }))}
                    value={professions.find(p => p.id === watch('profession_id')) ? { value: watch('profession_id'), label: professions.find(p => p.id === watch('profession_id')).profession } : null}
                    onChange={opt => setValue('profession_id', opt ? opt.value : '')}
                    isClearable
                    placeholder="Sélectionner une profession"
                    classNamePrefix="react-select"
                    styles={selectStyles}
                  />
                </div>
                <button type="button" onClick={() => setShowProfessionModal(true)} className="px-2 py-1 bg-primary-600 text-white rounded hover:bg-primary-700">+</button>
              </div>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Nom *</label>
              <input {...register('nom', { required: true })} className="block w-full rounded-lg border border-gray-300 dark:border-gray-600 dark:bg-gray-700 dark:text-gray-200 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500" />
              {errors.nom && <span className="text-red-500 dark:text-red-400 text-xs mt-1">Champ obligatoire</span>}
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Prénom *</label>
              <input {...register('prenom', { required: true })} className="block w-full rounded-lg border border-gray-300 dark:border-gray-600 dark:bg-gray-700 dark:text-gray-200 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500" />
              {errors.prenom && <span className="text-red-500 dark:text-red-400 text-xs mt-1">Champ obligatoire</span>}
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Religion</label>
              <div className="flex items-center gap-2">
                <div className="flex-1">
                  <Select
                    options={religions.map(r => ({ value: r.id, label: r.religion }))}
                    value={religions.find(r => r.id === watch('religion_id')) ? { value: watch('religion_id'), label: religions.find(r => r.id === watch('religion_id')).religion } : null}
                    onChange={opt => setValue('religion_id', opt ? opt.value : '')}
                    isClearable
                    placeholder="Sélectionner une religion"
                    classNamePrefix="react-select"
                    styles={selectStyles}
                  />
                </div>
                <button type="button" onClick={() => setShowReligionModal(true)} className="px-2 py-1 bg-primary-600 text-white rounded hover:bg-primary-700">+</button>
              </div>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Email</label>
              <input {...register('email')} className="block w-full rounded-lg border border-gray-300 dark:border-gray-600 dark:bg-gray-700 dark:text-gray-200 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500" />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Téléphone 1</label>
              <input {...register('telmob1')} className="block w-full rounded-lg border border-gray-300 dark:border-gray-600 dark:bg-gray-700 dark:text-gray-200 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500" />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Téléphone 2</label>
              <input {...register('telmob2')} className="block w-full rounded-lg border border-gray-300 dark:border-gray-600 dark:bg-gray-700 dark:text-gray-200 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500" />
            </div>
            <div className="col-span-2">
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Adresse</label>
              <input {...register('adresse')} className="block w-full rounded-lg border border-gray-300 dark:border-gray-600 dark:bg-gray-700 dark:text-gray-200 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500" />
            </div>
          </div>
          <div className="flex justify-end space-x-2 mt-6">
            <button type="button" className="px-4 py-2 bg-gray-200 dark:bg-gray-700 dark:text-gray-200 rounded-lg hover:bg-gray-300 dark:hover:bg-gray-600" onClick={onClose}>Annuler</button>
            <button type="submit" className="px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700">Enregistrer</button>
          </div>
        </form>
        {showProfessionModal && (
          <ProfessionModal
            onClose={() => setShowProfessionModal(false)}
            onSuccess={async (newProf) => {
              setShowProfessionModal(false);
              const res = await api.get('/professions');
              setProfessions(res.data.data || []);
              if (newProf && newProf.id) {
                setValue('profession_id', newProf.id);
              }
            }}
          />
        )}
        {showReligionModal && (
          <ReligionModal
            onClose={() => setShowReligionModal(false)}
            onSuccess={async (newRel) => {
              setShowReligionModal(false);
              const res = await api.get('/religions');
              setReligions(res.data.data || []);
              if (newRel && newRel.id) {
                setValue('religion_id', newRel.id);
              }
            }}
          />
        )}
      </div>
    </div>
  );
};

export default ParentModal;